export default {
  formId: "qr-code",
  formField: {
    description: {
      name: "description",
      label: "Clock Name",
      type: "text",
      errorMsg: "Clock Name is required.",
      invalidMsg: "Clock Name is invalid",
    },
    macAddress: {
      name: "macAddress",
      label: "Serial Number",
      type: "text",
      errorMsg: "Serial Number is required.",
      invalidMsg: "Serial Number is invalid",
    },
    deviceMacAddress: {
      name: "deviceMacAddress",
      label: "Android Id",
      type: "text",
      errorMsg: "Android Id is required.",
      invalidMsg: "Android Id is invalid",
    },
    location: {
      name: "location",
      label: "Location",
      type: "select",
      errorMsg: "location is required.",
      invalidMsg: "Location is not valid",
    },
    timezone: {
      name: "timezone",
      label: "Timezone",
      type: "select",
      errorMsg: "Timezone is required.",
      invalidMsg: "Timezone is not valid",
    },
    project: {
      name: "project",
      label: "SubAccount",
      type: "text",
      errorMsg: "SubAccount is required.",
      invalidMsg: "SubAccount is invalid",
    },
    status: {
      name: "status",
      label: "Status",
      type: "switch",
      errorMsg: "Status is required.",
      invalidMsg: "Status is invalid",
    },
    // profileImage: {
    //   name: "profileImage",
    //   label: "Activate to take profile image when clocking out",
    //   type: "switch",
    //   errorMsg: "Status is required.",
    //   invalidMsg: "Status is invalid",
    // },
    // signShift: {
    //   name: "signShift",
    //   label: "Activate to sign shift when clocking out",
    //   type: "switch",
    //   errorMsg: "Status is required.",
    //   invalidMsg: "Status is invalid",
    // },
    // collectIP: {
    //   name: "collectIP",
    //   label: "Collect ip address every time employee clock in or clock out",
    //   type: "switch",
    //   errorMsg: "Status is required.",
    //   invalidMsg: "Status is invalid",
    // },
  },
};
